
import { showProfile } from '../global/helper';

const ProfileCard = ({player}) => {
    return (
        <img src={player?.Photo} height="40" width="40" 
            onError={(e) => {
                e.target.onerror = null; // prevent infinite loop
                e.target.src = "https://golfez.s3.ap-south-1.amazonaws.com/Public/PGL/User/default_user.png";               
                e.target.removeAttribute("data-toggle");
                e.target.removeAttribute("data-trigger");
                e.target.removeAttribute("data-placement");
                e.target.removeAttribute("data-html");
                e.target.removeAttribute("data-content");
            }}

            data-toggle="kt-popover" data-trigger="hover click"
            data-placement="left" data-html="true"
            data-content={showProfile(player)}
            alt="banner-image"
        /> 
    );
}

export default ProfileCard;
